import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthModule } from '../auth/auth.module';
import { SharedModule } from '../shared/shared.module';
import { AdminGeneralComponent } from './admin-general/admin-general.component';
import { AdminRoutingModule } from './admin-routing.module';
import { GlobalComponent } from './global/global.component';
import { ImportComponent } from './import/import.component';
import { MergeComponent } from './merge/merge.component';
import { StructureAddressFormComponent } from './structures/structure-details/structure-address/structure-address-form/structure-address-form.component';
import { StructureAddressComponent } from './structures/structure-details/structure-address/structure-address.component';
import { StructureDetailsComponent } from './structures/structure-details/structure-details.component';
import { StructureGlobalComponent } from './structures/structure-details/structure-global/structure-global.component';
import { StructureSupportPlacesComponent } from './structures/structure-details/structure-support-places/structure-support-places.component';
import { StructuresComponent } from './structures/structures.component';
import { UserDetailsComponent } from './users/user-details/user-details.component';
import { UsersComponent } from './users/users.component';
import { PerformanceMonitorComponent } from './performance-monitor/performance-monitor.component';

@NgModule({
  declarations: [
    GlobalComponent,
    StructuresComponent,
    StructureDetailsComponent,
    ImportComponent,
    UsersComponent,
    UserDetailsComponent,
    MergeComponent,
    AdminGeneralComponent,
    StructureSupportPlacesComponent,
    StructureAddressComponent,
    StructureGlobalComponent,
    StructureAddressFormComponent,
    PerformanceMonitorComponent,
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    AuthModule,
    SharedModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    RouterModule,
    FontAwesomeModule,
    MatSlideToggleModule,
    NgSelectModule,
  ],
})
export class AdminModule {}
